<template>
  <div>
    <v-card>
    <v-card-title>
      Enrollments
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="payments"
      :search="search"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.siesa_id }}</td>
        <td class="text-xs-center">{{ props.item.siesa_payer }}</td>
        <td class="text-xs-center">{{ props.item.student }}</td>
        <td class="text-xs-center">{{ props.item.payment_date }}</td>
        <td class="text-xs-center">{{ props.item.price }}</td>
        <td class="text-xs-center">{{ props.item.payment_method }}</td>
        <td class="text-xs-center">
          <v-btn block outline color="info" @click="details(props.item.detail)">
            {{ $t('extracurriculares.pay_reserve.details') }}
            </v-btn>
        </td>
      </template>
    </v-data-table>
  </v-card>
  <v-dialog
    v-model="detail_modal"
    max-width="600px"
    transition="dialog-transition"
  >
    <v-card>
      <v-data-table
        :headers="detail_headers"
        :items="reserves_detail"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.course.name }}</td>
          <td class="text-xs-center">{{ props.item.schedule.name }}</td>
          <td class="text-xs-center">{{ props.item.created_at }}</td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-layout row wrap justify-center>
            <v-btn @click="detail_modal = false" color="primary">
              {{ $t('close') }}
            </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'enrollment-report-view',
    data() {
      return {
        headers: [
          { text: this.$t('reports.headers.siesa_id'), align: 'center', value: 'siesa_id' },
          { text: this.$t('reports.headers.siesa_payer'), align: 'center', value: 'siesa_payer' },
          { text: this.$t('reports.headers.student'), align: 'center', value: 'student' },
          { text: this.$t('reports.headers.payment_date'), align: 'center', value: 'payment_date' },
          { text: this.$t('reports.headers.price'), align: 'center', value: 'price' },
          { text: this.$t('reports.headers.payment_method'), align: 'center', value: 'payment_method' },
          { text: this.$t('reports.headers.actions'), align: 'center', value: 'payment_method' },
        ],
        payments: [],
        loading: false,
        search: '',
        reserves_detail: [],
        detail_modal: false,
        detail_headers: [
          { text: this.$t('reports.headers.course'), align: 'center', value: 'siesa_id' },
          { text: this.$t('reports.headers.schedule'), align: 'center', value: 'siesa_payer' },
          { text: this.$t('reports.headers.reservation_date'), align: 'center', value: 'student' },
        ],
      }
    },
    created () {
      this.getReportData();
    },
    methods: {
      getReportData() {
        this.loading = true
        axios.get('/api/extracurriculares/report/user')
          .then(resp => {
            if (resp.status === 200) {
              // this.data = resp.data.data
              console.log(resp.data.data)
              resp.data.data.forEach(payment => {
                console.log(payment)
                this.payments.push({
                  siesa_id: payment.extracurriculares[0].student_id == 0 && payment.extracurriculares[0].user_info ? payment.extracurriculares[0].user_info.nit : payment.extracurriculares[0].family.siesa_id,
                  siesa_payer: this.getPayerName(payment, payment.extracurriculares[0].user_info && payment.extracurriculares[0].user_info.nit, payment.extracurriculares[0].family && payment.extracurriculares[0].family.siesa_id),
                  payment_date: this.formatDate(payment.payment_date || payment.created_at),
                  price: `$ ${this.formatNumber(payment.service_payment_total)}`,
                  payment_method: payment.payment_type,
                  student: payment.extracurriculares[0].student_id == 0 ? payment.extracurriculares[0].student_ext.full_name : payment.extracurriculares[0].student.full_name,
                  detail: payment.extracurriculares
                })
              })
            }
            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      getPayerName(payment, id, id_fam) {
        let payer = ''
        console.log(id, id_fam)
        if (payment.extracurriculares[0].student_id == 0 && id) {
          payer = `${payment.extracurriculares[0].user_info.full_name}`
        } else {
          console.log('here')
          const family = payment.extracurriculares[0].family
          if (id_fam == payment.extracurriculares[0].family.father_id) {
            payer = `${family.father} ${family.father_last_name}`
          }

          if (id_fam == payment.extracurriculares[0].family.mother_id) {
            payer = `${family.mother} ${family.mother_last_name}`
          }
        }

        return payer
      },
      details(reserves) {
        this.reserves_detail = reserves
        this.detail_modal = true
      },
      formatDate(date) {
        let date_to_format = new Date(date)
        let formatted_date = date_to_format.getFullYear() + "-" + (date_to_format.getMonth() + 1) + "-" + date_to_format.getDate() + " " + date_to_format.getHours() + ":" + date_to_format.getMinutes() + ":" + date_to_format.getSeconds()
        return formatted_date
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/reports/enrollment_users.vue